import React from "react";
import { getIn } from "formik";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

function AutoCompleteField({ field, form, label, options = [], onValueChange, isRequired, isLoading, ...props }) {
	const errorText = getIn(form.touched, field.name) && getIn(form.errors, field.name);
	return (
		<FormControl fullWidth error={!!errorText}>
			{field.name && (
				<InputLabel sx={{ ml: -1.6, textTransform: "capitalize" }} shrink htmlFor={field.name} >
					<Typography variant="body1">
						{label}
						{isRequired && (
							<Typography variant="body1" color="error" component="span">
								{" *"}
							</Typography>
						)}
					</Typography>
				</InputLabel>
			)}
			{/* <Autocomplete
				{...props}
				id={field.name}
				filterOptions={(x) => x}
				options={options}
				sx={{
					backgroundColor: "#F7FAFF",
					border: "0.5px solid #DC143C",
					borderRadius: "6px",
					mt: 2,
					"& fieldset": { border: "none" },
					"& .MuiOutlinedInput-root .MuiAutocomplete-input": { padding: " 0px 0" }
				}}
				onChange={(_, value) => {
					if (value === null) {
						form.setFieldValue(field.name, "");
					}
					if (value) {
						form.setFieldValue(field.name, value.id);
						onValueChange?.(value);
					}
				}}
				renderOption={(props, option) => (
					<>
						{
							!isLoading && <li {...props} key={option.value}>
								<Typography variant="body1">{option.value}</Typography>
							</li>
						}
						{
							isLoading && <li>
								<Typography variant="body1">...loading</Typography>
							</li>
						}
					</>
				)}
				renderInput={(params) => (
					<TextField
						// placeholder={label ? `Enter ${label?.toLowerCase()}` : undefined}
						error={Boolean(errorText)}
						helperText={errorText}
						label={undefined}
						name={field.name}
						{...params}
						
					/>
				)}
				value={options.find((option) => option.value === field.value) ?? null}
			/> */}
			<Autocomplete
				{...props}
				id={field.name}
				filterOptions={(x) => x}
				options={options}
				sx={{
					border: "0.5px solid #DC143C",
					borderRadius: "6px",
					mt: 2,
					"& fieldset": { border: "none" },
					"& .MuiOutlinedInput-root .MuiAutocomplete-input": { padding: " 0px 0" }
				}}
				onChange={(_, value) => {
					if (value === null) {
						form.setFieldValue(field.name, "");
					} else {
						form.setFieldValue(field.name, value.id);
						onValueChange?.(value);
					}
				}}
				getOptionLabel={(option) => option.value} // Ensure proper display of selected value
				isOptionEqualToValue={(option, val) => option.id === val} // Fix value selection issue
				renderOption={(props, option) => (
					!isLoading ? (
						<li {...props} key={option.id}>
							<Typography variant="body1">{option.value}</Typography>
						</li>
					) : (
						<li>
							<Typography variant="body1">...loading</Typography>
						</li>
					)
				)}
				renderInput={(params) => (
					<TextField
						// error={Boolean(errorText)}
						// helperText={errorText}
						label={undefined}
						name={field.name}
						{...params}
					/>
				)}
				value={options.find((option) => option.id === field.value) || null} // Match by id instead of value
			/>
			<Typography variant="body2" fontSize={"10px"} color="#DC143C" component="span">
				{errorText}
			</Typography>
		</FormControl>
	);
}

export { AutoCompleteField };
